const FaqItem = {
  resizeTimeout: null,
  previousWindowInnerWidth: window.innerWidth,
  SELECTORS: {
    item: '[data-js-faq-item]',
    button: '[data-js-faq-item-button]',
    definition: '[data-js-faq-item-definition]',
    answer: '[data-js-faq-item-answer]',
  },
  CLASSES: {
    itemActive: 'faq-item--active',
  },
  CSS_VARIABLES: {
    itemDefinitionHeight: '--faq-item-definition-height',
  },
  init() {
    const items = document.querySelectorAll(this.SELECTORS.item);

    items.forEach((item) => {
      const button = item.querySelector(this.SELECTORS.button);
      const definition = item.querySelector(this.SELECTORS.definition);
      const answer = item.querySelector(this.SELECTORS.answer);

      if (!button || !definition || !answer) {
        return;
      }

      definition.style.setProperty(this.CSS_VARIABLES.itemDefinitionHeight, `${answer.scrollHeight}px`);

      button.onclick = () => {
        button.ariaExpanded = button.ariaExpanded === 'true' ? false : true;

        item.classList.toggle(this.CLASSES.itemActive);
      };
    });
  },
};

window.addEventListener('DOMContentLoaded', () => {
  FaqItem.init();
});

document.addEventListener('shopify:section:load', () => {
  FaqItem.init();
});

document.addEventListener('shopify:section:reorder', () => {
  FaqItem.init();
});

function reinitializeFaqItemOnWindowResize() {
  if (window.innerWidth === FaqItem.previousWindowInnerWidth) {
    return;
  }

  FaqItem.previousWindowInnerWidth = window.innerWidth;

  clearTimeout(FaqItem.resizeTimeout);

  FaqItem.resizeTimeout = setTimeout(() => {
    FaqItem.init();
  }, 1000);
}

window.addEventListener('resize', () => {
  reinitializeFaqItemOnWindowResize();
});
